/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import { withAnalytics } from '@veneer/analytics';
import {
  Button,
  IconArrowLeft,
  IconArrowRight,
  useDirection,
  useMediaQuery
} from '@veneer/core';
import React, { forwardRef } from 'react';
import { breakpoints } from '../../base';
import './styles.scss';
import { BackNavigationButtonProps } from './types';
import { generateID } from '../../base/helper';

/**
 * UI Toolkit Back Navigation button component based on Veneer Button
 * @public
 */
const TBackNavigationButton = forwardRef<
  HTMLButtonElement,
  BackNavigationButtonProps
>((props, ref) => {
  const {
    id = generateID('clientos-ui-toolkit-back-navigation-button'),
    buttonText,
    onClick,
    ...rest
  } = props;
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.sm})`);
  const rtl = useDirection().isRTL;

  return (
    <Button
      id={id}
      {...rest}
      ref={ref}
      leadingIcon={rtl ? <IconArrowRight /> : <IconArrowLeft />}
      onClick={onClick}
      name={buttonText}
      className="clientos-ui-toolkit-back-navigation-button"
    >
      {isMobile && buttonText.length > 8 ? null : (
        <span className="label">{buttonText}</span>
      )}
    </Button>
  );
});

TBackNavigationButton.displayName = 'BackNavigationButton';

export const BackNavigationButtonAnalytics = withAnalytics(
  TBackNavigationButton
);
export default TBackNavigationButton;
